export default __webpack_public_path__ + "static/media/trr-drink-juicecocktail-matchahaven.375a7a47.png";